import React, { useEffect, useState } from "react"
import axios from "axios"
import { useNavigate } from "react-router-dom"
import "./Logs.css"

function getLogVariant(action) {
  const a = action.toLowerCase()
  if (a.startsWith("created"))                      return "log-created"
  if (a.startsWith("deleted"))                      return "log-deleted"
  if (a.startsWith("accepted"))                     return "log-accepted"
  if (a.startsWith("rejected"))                     return "log-rejected"
  if (a.startsWith("started") || a.startsWith("unstarted")) return "log-started"
  if (a.startsWith("ended")   || a.startsWith("un-ended"))  return "log-ended"
  return "log-other"
}

const Logs = ({ user }) => {
  const [logs, setLogs] = useState([])
  const [filteredLogs, setFilteredLogs] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize] = useState(10)
  const [searchQuery, setSearchQuery] = useState("")
  const [adminFilter, setAdminFilter] = useState("All")
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [error, setError] = useState(null)
  const navigate = useNavigate()

  const fetchLogs = async () => {
    try {
      setError(null)
      const res = await axios.get("/api/logs", {
        headers: { Authorization: `Bearer ${user.token}` }
      })
      setLogs(res.data)
      setFilteredLogs(res.data)
    } catch (err) {
      console.error(err)
      setError(err.response?.data?.message || "Failed to load logs")
    }
  }

  useEffect(() => {
    if (!user) {
      navigate("/login")
      return
    }
    fetchLogs()
  }, [user, navigate])

  useEffect(() => {
    let temp = [...logs]
    if (adminFilter !== "All")
      temp = temp.filter(log => log.admin === adminFilter)
    if (searchQuery.trim())
      temp = temp.filter(log => log.action.toLowerCase().includes(searchQuery.toLowerCase()))
    if (startDate)
      temp = temp.filter(log => new Date(log.timestamp) >= new Date(startDate))
    if (endDate)
      temp = temp.filter(log => new Date(log.timestamp) <= new Date(endDate))
    setFilteredLogs(temp)
    setCurrentPage(1)
  }, [logs, adminFilter, searchQuery, startDate, endDate])

  const totalPages = Math.ceil(filteredLogs.length / pageSize)
  const currentLogs = filteredLogs.slice((currentPage - 1) * pageSize, currentPage * pageSize)
  const uniqueAdmins = ["All", ...Array.from(new Set(logs.map(log => log.admin)))]

  return (
    <div className="logs-page">
      <div className="logs-header">
        <div className="container">
          <h1 className="font-display">Admin Logs</h1>
          <p>Full audit trail of all admin actions</p>
        </div>
      </div>

      <div className="container">
        <div className="logs-filters-card">
          <input
            className="logs-filter-search"
            type="text"
            placeholder="Search actions..."
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
          />
          <select value={adminFilter} onChange={e => setAdminFilter(e.target.value)}>
            {uniqueAdmins.map(admin => (
              <option key={admin} value={admin}>{admin}</option>
            ))}
          </select>
          <input
            type="date"
            value={startDate}
            onChange={e => setStartDate(e.target.value)}
          />
          <input
            type="date"
            value={endDate}
            onChange={e => setEndDate(e.target.value)}
          />
        </div>

        {error ? (
          <p className="logs-empty" style={{ color: "var(--error)" }}>{error}</p>
        ) : filteredLogs.length === 0 ? (
          <p className="logs-empty">No logs found.</p>
        ) : (
          <div className="logs-list">
            {currentLogs.map(log => (
              <div key={log._id} className={`log-item ${getLogVariant(log.action)}`}>
                <span className="log-admin">{log.admin}</span>
                <span className="log-action">{log.action}</span>
                <span className="log-timestamp">{new Date(log.timestamp).toLocaleString()}</span>
              </div>
            ))}
          </div>
        )}

        {totalPages > 1 && (
          <div className="logs-pagination">
            <button
              className="btn btn-secondary btn-sm"
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Prev
            </button>
            <span className="logs-page-info">Page {currentPage} of {totalPages}</span>
            <button
              className="btn btn-secondary btn-sm"
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default Logs
